<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill-rule="evenodd"
    stroke-linejoin="round"
    stroke-miterlimit="2"
    clip-rule="evenodd"
    viewBox="0 0 95 113"
    :width="width"
    :height="width"
  >
    <g fill-rule="nonzero">
      <path
        :fill="iconColor"
        d="M88.2 15.4a34.2 34.2 0 0 0-45.8-9.8l-26 16.6a30 30 0 0 0-13.6 20C1.6 49 2.7 56.2 6 62.4a30 30 0 0 0-4.4 11.2C0 82 1.9 90.7 6.9 97.7a34.2 34.2 0 0 0 45.8 9.8l26-16.5a30 30 0 0 0 13.6-20c1.3-6.9.2-14-3.1-20.2 2.2-3.4 3.8-7.2 4.5-11.2a32 32 0 0 0-5.5-24.1"
      ></path>
      <path
        fill="#fff"
        d="M39.9 99.2a20.8 20.8 0 0 1-22.2-8.3A19.1 19.1 0 0 1 15 74l.5-1.5 1.3 1c3.1 2.2 6.5 4 10.2 5l1 .4v1c-.2 1.3.2 2.7 1 3.8a6.3 6.3 0 0 0 6.7 2.5l1.6-.7 26-16.6a5.4 5.4 0 0 0 2.5-3.7c.3-1.5-.1-3-1-4.4a6.3 6.3 0 0 0-6.7-2.4c-.6.1-1.1.4-1.6.7l-10 6.3c-1.6 1-3.4 1.8-5.3 2.3A20.8 20.8 0 0 1 19 59.5c-3-4.2-4.2-9.4-3.2-14.5a18 18 0 0 1 8-12L50 16.2a19 19 0 0 1 5.3-2.3 20.7 20.7 0 0 1 22.2 8.2 19.1 19.1 0 0 1 2.6 17l-.5 1.5-1.3-1c-3-2.3-6.5-4-10.2-5.1l-1-.3.1-1c.1-1.4-.3-2.8-1-3.9a6.2 6.2 0 0 0-8.3-1.7L31.8 44.3a5.5 5.5 0 0 0-2.5 3.6c-.2 1.6.1 3.1 1 4.4a6.3 6.3 0 0 0 6.7 2.5 6 6 0 0 0 1.6-.7l10-6.4a20.7 20.7 0 0 1 27.5 6c3 4.1 4.2 9.4 3.3 14.4a18 18 0 0 1-8.1 12.1L45.2 96.8c-1.6 1-3.4 1.9-5.3 2.4"
      ></path>
    </g></svg
></template>

<script>
export default {
  name: "SvelteIcon",
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>

<style scoped></style>
